import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorPassport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M20.75 4A1.75 1.75 0 0 0 19 2.25H3.25v19.5H19A1.75 1.75 0 0 0 20.75 20V4ZM19 3.75a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25H4.75V3.75H19ZM8 16.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M10.043 7.098a3.519 3.519 0 0 0-.907.89c.211.08.43.152.653.214.067-.378.152-.75.254-1.104Zm1.248-.526c-.229.52-.407 1.165-.523 1.838a8.406 8.406 0 0 0 2.467 0c-.111-.67-.282-1.315-.5-1.833a3.513 3.513 0 0 0-1.444-.005Zm-1.632 2.63a8.613 8.613 0 0 1-.977-.318C8.564 9.234 8.5 9.61 8.5 10c0 .468.092.914.258 1.322.292-.111.593-.208.904-.29-.03-.3-.044-.605-.044-.914 0-.296.014-.604.04-.915Zm.989 1.63a8.503 8.503 0 0 1-.03-.714c0-.233.01-.473.027-.715a9.41 9.41 0 0 0 2.71 0c.017.243.027.483.027.715 0 .242-.01.48-.03.715a9.414 9.414 0 0 0-2.704 0Zm-.835 1.195c-.183.05-.363.107-.538.17.22.272.479.51.769.706a8.836 8.836 0 0 1-.23-.876Zm1.506 1.407a7.6 7.6 0 0 1-.527-1.611 8.4 8.4 0 0 1 2.415 0 7.604 7.604 0 0 1-.527 1.61 3.513 3.513 0 0 1-1.36 0Zm2.653-6.326c.098.35.179.72.242 1.093a7.61 7.61 0 0 0 .65-.213 3.52 3.52 0 0 0-.892-.88Zm-.016 5.795c.09-.284.168-.576.23-.876.184.05.363.107.539.17a3.52 3.52 0 0 1-.77.706ZM15.5 10c0 .468-.092.914-.258 1.322a8.65 8.65 0 0 0-.904-.29c.029-.3.044-.605.044-.914 0-.294-.014-.602-.04-.915.336-.088.662-.195.976-.319.118.35.182.726.182 1.116Zm-8 0a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorPassport;
